import axios from 'axios';
import { env } from '@config/env';
import { installInterceptors } from './interceptors';
import { navigateTo } from '@shared/lib/navigation';
import { useAuthStore } from '@shared/stores/authStore';

/**
 * Core API client — handles SSO, domain resolution, cross-tenant identity.
 * Base URL is fixed at build time per env file; tenant headers are still
 * attached but ignored on most Core endpoints.
 */
export const coreApi = axios.create({
  baseURL: env.coreApiUrl,
  timeout: 20_000,
  headers: { 'Content-Type': 'application/json' },
});

installInterceptors(coreApi, {
  refresh: async (refreshToken) => {
    const { data } = await axios.post(
      `${env.coreApiUrl}/portal-auth/refresh`,
      { refresh_token: refreshToken },
      { headers: { 'Content-Type': 'application/json' } },
    );
    return {
      accessToken: data.accessToken ?? data.access_token,
      refreshToken: data.refreshToken ?? data.refresh_token,
    };
  },
  onRefreshFailed: () => {
    void useAuthStore.getState().signOut();
    navigateTo('/login', { replace: true });
  },
});
